import React from 'react';

class ListItemThongKeGQDKN extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    let Item = this.props.item || {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{Item.donVi ? Item.donVi.ten : (Item.capDonVi ? Item.capDonVi.ten : '')}</td>

        <td className='txt-center'>{Item.tongSoDonKhieuNai ? Item.tongSoDonKhieuNai : 0}</td>
        <td className='txt-center'>{Item.donNhanTrongKyBaoCao ? Item.donNhanTrongKyBaoCao : 0}</td>
        <td className='txt-center'>{Item.donTonKyTruocChuyenSang ? Item.donTonKyTruocChuyenSang : 0}</td>
        <td className='txt-center'>{Item.tongSoVuViec ? Item.tongSoVuViec : 0}</td>

        <td className='txt-center'>{Item.soDonThuocThamQuyen ? Item.soDonThuocThamQuyen : 0}</td>
        <td className='txt-center'>{Item.soVuViecThuocThamQuyen ? Item.soVuViecThuocThamQuyen : 0}</td>
        <td className='txt-center'>{Item.soVuViecGiaiQuyetBangQDHanhChinh ? Item.soVuViecGiaiQuyetBangQDHanhChinh : 0}</td>
        <td className='txt-center'>{Item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc ? Item.soVuViecRutDonThongQuaGiaiThichThuyetPhuc : 0}</td>

        <td className='txt-center'>{Item.khieuNaiDung ? Item.khieuNaiDung : 0}</td>
        <td className='txt-center'>{Item.khieuNaiSai ? Item.khieuNaiSai : 0}</td>
        <td className='txt-center'>{Item.khieuNaiDungMotPhan ? Item.khieuNaiDungMotPhan : 0}</td>
        <td className='txt-center'>{Item.giaiQuyetLan1 ? Item.giaiQuyetLan1 : 0}</td>

        <td className='txt-center'>{Item.congNhanQuyetDinhGiaiQuyetLan1 ? Item.congNhanQuyetDinhGiaiQuyetLan1 : 0}</td>
        <td className='txt-center'>{Item.huySuaQuyetDinhGiaiQuyetLan1 ? Item.huySuaQuyetDinhGiaiQuyetLan1 : 0}</td>

        <td className='txt-right'>{Item.kienNghiThuHoiChoNhaNuocTien ? Item.kienNghiThuHoiChoNhaNuocTien : 0}</td>
        <td className='txt-right'>{Item.kienNghiThuHoiChoNhaNuocDat ? Item.kienNghiThuHoiChoNhaNuocDat : 0}</td>
        <td className='txt-right'>{Item.traLaiChoCongDanTien ? Item.traLaiChoCongDanTien : 0}</td>
        <td className='txt-right'>{Item.traLaiChoCongDanDat ? Item.traLaiChoCongDanDat : 0}</td>

        <td className='txt-center'>{Item.soNguoiDuocTraLaiQuyenLoi ? Item.soNguoiDuocTraLaiQuyenLoi : 0}</td>

        <td className='txt-center'>{Item.kienNghiXuLyHanhChinhTongSoNguoi ? Item.kienNghiXuLyHanhChinhTongSoNguoi : 0}</td>
        <td className='txt-center'>{Item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? Item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0}</td>

        <td className='txt-center'>{Item.soVuChuyenCoQuanDieuTra ? Item.soVuChuyenCoQuanDieuTra : 0}</td>
        <td className='txt-center'>{Item.soDoiTuongChuyenCoQuanDieuTra ? Item.soDoiTuongChuyenCoQuanDieuTra : 0}</td>
        <td className='txt-center'>{Item.soVuDaKhoiTo ? Item.soVuDaKhoiTo : 0}</td>
        <td className='txt-center'>{Item.soDoiTuongDaKhoiTo ? Item.soDoiTuongDaKhoiTo : 0}</td>

        <td className='txt-center'>{Item.soVuViecGiaiQuyetDungThoiHan ? Item.soVuViecGiaiQuyetDungThoiHan : 0}</td>
        <td className='txt-center'>{Item.soVuViecGiaiQuyetQuaThoiHan ? Item.soVuViecGiaiQuyetQuaThoiHan : 0}</td>

        <td className='txt-center'>{Item.tongSoQuyetDinhPhaiToChucThucHien ? Item.tongSoQuyetDinhPhaiToChucThucHien : 0}</td>
        <td className='txt-center'>{Item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? Item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0}</td>

        <td className='txt-right'>{Item.tienPhaiThuChoNhaNuoc ? Item.tienPhaiThuChoNhaNuoc : 0}</td>
        <td className='txt-right'>{Item.datPhaiThuChoNhaNuoc ? Item.datPhaiThuChoNhaNuoc : 0}</td>
        <td className='txt-right'>{Item.tienDaThuChoNhaNuoc ? Item.tienDaThuChoNhaNuoc : 0}</td>
        <td className='txt-right'>{Item.datDaThuChoNhaNuoc ? Item.datDaThuChoNhaNuoc : 0}</td>

        <td className='txt-right'>{Item.tienPhaiTraChoCongDan ? Item.tienPhaiTraChoCongDan : 0}</td>
        <td className='txt-right'>{Item.datPhaiTraChoCongDan ? Item.datPhaiTraChoCongDan : 0}</td>
        <td className='txt-right'>{Item.tienDaTraChoCongDan ? Item.tienDaTraChoCongDan : 0}</td>
        <td className='txt-right'>{Item.datDaTraChoCongDan ? Item.datDaTraChoCongDan : 0}</td>

        <td className='ghi-chu'>{Item.ghiChu ? Item.ghiChu : ''}</td>
      </tr>
    );
  }
}

export default ListItemThongKeGQDKN;


// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemThongKeGQDKN.jsx